import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";

const services = [
    // {
    //     "title": "Interoperability Consulting Services",
    //     "description": "We provide expert consulting to help healthcare organizations integrate systems seamlessly, ensuring smooth data exchange and compliance.",
    //     "link": "/Services/Ourservices/HealthcareIntegration"
    // },
    {
        "title": "Custom Healthcare Platform Development",
        "description": "We deliver end-to-end healthcare software—from EMR modules to chronic care apps—aligned with clinical workflows and HIPAA/GDPR standards.",
        "link": "/Services/Ourservices/Custom"
    },
    // {
    //     "title": "EHR System Integration Services",
    //     "description": "Our team specializes in developing and managing EHR integrations, ensuring efficient and secure data flow between healthcare systems.",
    //     "link": "/Services/Ourservices/Ehr"
    // },
    // {
    //     "title": "LIS Data Integration Solutions",
    //     "description": "We streamline Laboratory Information System (LIS) integrations, enabling fast and accurate data exchange using industry standards.",
    //     "link": "/Services/Ourservices/Lis"
    // },
    {
        "title": "HL7/FHIR Interoperability Solutions",
        "description": "We enable secure, standards-based data exchange using HL7, CDA, and FHIR to achieve true interoperability across healthcare systems.",
        "link": "/Services/Ourservices/Hl7"
    },
    // {
    //     "title": "FHIR-Based Healthcare Connectivity",
    //     "description": "We specialize in FHIR integration, ensuring secure and standardized healthcare data exchange for improved interoperability.",
    //     "link": "/Services/Ourservices/FhirHealth"
    // },
    // {
    //     "title": "Mirth Connect Implementation & Training",
    //     "description": "Our experts provide Mirth Connect consulting and training to help organizations build, manage, and optimize healthcare integrations effectively.",
    //     "link": "/Services/Ourservices/MirthConnect"
    // },
    // {
    //     "title": "Telemedicine Platform Integration",
    //     "description": "We develop and integrate telemedicine solutions to enable seamless remote patient monitoring, consultations, and data sharing.",
    //     "link": "/Services/ourservices/Telemedicine"
    // },
    // {
    //     "title": "HIPAA Compliance & Security Consulting",
    //     "description": "Our team ensures that your healthcare IT infrastructure meets HIPAA compliance standards, securing patient data and preventing breaches.",
    //     "link": "/Services/ourservices/Hiippa"
    // },
    {
        "title": "Advanced Clinical Data Analytics & Insights",
        "description": "We build clinical analytics platforms that help providers track patient trends, assess treatment outcomes, and support data-driven care decisions.",
        "link": "/Services/Ourservices/AdvanceHDA"
    },
    {
        "title": "Revenue Cycle Management (RCM) & Payer Integration",
        "description": "We streamline RCM processes—from eligibility checks to claims and payments—by integrating with payer systems to reduce denials and boost reimbursements.",
        "link": "/Services/Ourservices/Revenue"
    },
    {
        "title": "AI-Driven Clinical Decision Support & Automation",
        "description": "We develop AI-driven diagnostic and predictive tools that enhance care delivery, support providers and patients, and ensure HIPAA compliance.",
        "link": "/Services/Ourservices/AI-Driven-Healthcare-Innovations"
    },
    {
        "title": "Provider & Patient Portal Development",
        "description": "We design user-friendly portals for scheduling, telehealth, records access, and communication—enhancing patient engagement and satisfaction.",
        "link": "/Services/Ourservices/PPES"
    },
    // {
    //     "title": "Blockchain-Powered Healthcare Security",
    //     "description": "We implement blockchain solutions to enhance the security, integrity, and transparency of healthcare data transactions.",
    //     "link": "/Services/Ourservices/Blockchain-Powered-Healthcare-Security"
    // }
]

const CustomArrow = ({ onClick, direction }) => (
    <button
        onClick={onClick}
        className={`absolute top-1/2 transform -translate-y-1/2 p-3 bg-white/50 backdrop-blur-md rounded-full shadow-lg text-gray-700 transition-all hover:scale-110 hover:bg-gradient-to-r from-blue-500 to-purple-500 hover:text-white 
        ${direction === "left" ? "left-0 ml-2 z-10" : "right-0 mr-2 z-10"} `}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 "
        >
            {direction === "left" ? (
                <path
                    fillRule="evenodd"
                    d="M15.707 19.707a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 1 1 1.414 1.414L9.414 12l6.293 6.293a1 1 0 0 1 0 1.414z"
                    clipRule="evenodd"
                />
            ) : (
                <path
                    fillRule="evenodd"
                    d="M8.293 19.707a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 1 0-1.414 1.414L14.586 12l-6.293 6.293a1 1 0 0 0 0 1.414z"
                    clipRule="evenodd"
                />
            )}
        </svg>
    </button>
);

const AutoScrollServices = () => {
    const navigate = useNavigate();

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        prevArrow: <CustomArrow direction="left" />,
        nextArrow: <CustomArrow direction="right" />,
        responsive: [
            {
                breakpoint: 1280, // Large Screens
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024, // Medium Screens (Tablets)
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768, // Mobile Screens
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        slidesToShow: 3,
        slidesToScroll: 2,
    };

    return (
        <div className="w-full p-6 mb-4 bg-gray-50">
            <h2 className="text-[24px] md:text-[30px] font-semibold text-center bg-gradient-to-l from-[#2a627a] text-gray-800 rounded-xl mb-6">
                Trusted Healthcare Services
            </h2>
            <Slider {...settings} className="space-x-4">
                {services.map((service, index) => (
                    <div key={index} className="px-4">
                        <div
                            // className="h-[220px] md:h-[250px] w-full sm:w-[90%] md:w-[80%] lg:w-[320px] flex flex-col justify-between p-6 bg-gradient-to-t from-blue-100  to-[#2a627a] rounded-xl shadow-xl cursor-pointer hover:scale-105 transition-transform duration-300 mx-auto my-4"
                            className="h-[220px] md:h-[250px] w-full sm:w-[90%] md:w-[80%] lg:w-[320px] flex flex-col justify-between p-6 bg-gradient-to-t from-gray-300 via-transparent to-gray-300 rounded-xl shadow-xl cursor-pointer hover:scale-105 transition-transform duration-300 mx-auto my-4"
                            onClick={() => navigate(service.link)}
                        >
                            <h3 className="text-lg md:text-lg font-bold text-center text-[#2a627a]">
                                {service.title}
                            </h3>
                            <p className="text-black font-base text-center text-xs md:text-sm mt-2">
                                {service.description}
                            </p>
                            <p className="text-[#2a627a] font-bold text-center relative mt-2 cursor-pointer transition-all duration-300 
                            before:content-[''] before:absolute before:bottom-0 before:left-1/2 before:w-0 before:h-[2px] 
                            before:bg-[#2a627a] before:transition-all before:duration-300 hover:before:w-[100px] hover:before:translate-x-[-50%]">
                                Learn More →
                            </p>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default AutoScrollServices;
